import styled from '@emotion/styled';
import * as DetailsLink from './columns/DetailsLink';
import { ITheme, Responsive, RowRole } from '../../../../ui';
import * as SolicitationTitle from './columns/SolicitationTitle';
import * as SolicitationType from './columns/SolicitationType';
import * as SolicitationCategory from './columns/SolicitationCategory';
import * as SolicitationLocation from './columns/SolicitationLocation';
import * as SolicitationDateDue from './columns/SolicitationDateDue';
import * as SolicitationStatus from './columns/SolicitationStatus';
import { Color } from '../../../../styles/Color';

const StyledRow = styled(RowRole)<{}, ITheme>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid ${Color.BorderCard};
	font-size: ${({ theme }) => theme.typography?.small?.size};
	font-weight: 400;
	color: ${({ theme }) => theme.color?.text?.light};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

export function SolicitationListHeader() {
	return (
		<StyledRow>
			<SolicitationTitle.Header />

			<SolicitationType.Header />

			<SolicitationCategory.Header />

			<SolicitationLocation.Header />

			<SolicitationDateDue.Header />

			<SolicitationStatus.Header />

			<DetailsLink.Header />
		</StyledRow>
	);
}
